<template>
  <div class="social-icons-loader">
    <div
      v-for="(index) in totalItems"
      :key="index">
      <vue-content-loading
        :width="200"
        :height="125">
        <circle
          :cx="circleSize"
          :cy="circleSize"
          :r="circleSize" />
      </vue-content-loading>
    </div>
  </div>
</template>
<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'SocialIconsLoader',
  components: {
    VueContentLoading,
  },
  data() {
    return {
      circleSize: 60,
      totalItems: 4,
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss">
.social-icons-loader {
  width: 300px;
  > div {
    display: inline-block;
    width: 60px;
    svg {
      height: 40px;
      width: 60px;
    }
  }
  // overflow: hidden;
  // svg {
  //   display: inline-block;
  // }
}
// @media (max-width: 768px) {
//   .show-loader-container{
//     overflow: hidden;
//     margin-top: 3.5rem;
//     svg {
//       height: 20px;
//       width: 180px;
//     }
//     .show-loader {
//       margin-top: 1rem;
//       svg {
//         height: 180px;
//         width: 180px;
//       }
//     }
//   }
// }
// @media (max-width: 576px) {
//   .show-loader-container{
//     overflow: hidden;
//     margin-top: 3.5rem;
//     svg {
//       height: 20px;
//       width: 100px;
//     }
//     .show-loader {
//       margin-top: 1rem;
//       svg {
//         height: 120px;
//         width: 120px;
//       }
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// app/src/components/loaders/SocialIconsLoader.vue